import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { MdPlayArrow } from 'react-icons/md'
import ReactPlayer from 'react-player/lazy'

import type { ReactElement, SyntheticEvent } from 'react'

import './styles.scss'

interface Props {
  autoplay?: boolean
  className?: string
  clickable?: boolean
  controls?: boolean
  filename?: string
  muted?: boolean
  onReady?: (player: ReactPlayer) => void
  onRefReady?: (player: ReactPlayer) => void
  url: string
}

const VideoPreview = ({
  autoplay,
  className,
  clickable = true,
  controls = true,
  filename,
  muted,
  onReady,
  onRefReady,
  url,
}: Props): ReactElement => {
  let playerRef: ReactPlayer | null = null

  const [isPlaying, setIsPlaying] = useState(!!autoplay)

  const [showPlayButton, setShowPlayButton] = useState(!autoplay)

  useEffect(() => {
    if (playerRef && onRefReady) {
      onRefReady(playerRef)
    }
  }, [onRefReady, playerRef])

  const handlePlayClick = (event: SyntheticEvent<HTMLDivElement>) => {
    event.preventDefault()

    if (clickable) {
      setIsPlaying((playing) => !playing)
      setShowPlayButton(false)
    }
  }

  const handlePause = () => {
    if (clickable) {
      setShowPlayButton(true)
      setIsPlaying(false)
    }
  }

  const handleStart = () => {
    if (clickable) {
      setIsPlaying(true)
      setShowPlayButton(false)
    }
  }

  const handlePlay = () => {
    if (clickable) {
      setIsPlaying(true)
      setShowPlayButton(false)
    }
  }

  const handleEnded = () => {
    if (clickable) {
      setIsPlaying(false)
    }
  }

  const setRef = (element: ReactPlayer) => {
    playerRef = element
  }

  return (
    <div className={classNames('video-preview-component', className)}>
      <div className="video-wrapper" onClick={handlePlayClick}>
        <ReactPlayer
          config={{ file: { attributes: { crossOrigin: 'anonymous' } } }}
          controls={controls}
          height="100%"
          muted={muted}
          onEnded={handleEnded}
          onPause={handlePause}
          onPlay={handlePlay}
          onReady={onReady}
          onStart={handleStart}
          playIcon={<></>}
          playing={isPlaying}
          ref={setRef}
          url={url}
          width="100%"
        />
        {showPlayButton ? (
          <div className="overlay-play-button">
            <MdPlayArrow color="#fff" size={30} />
          </div>
        ) : null}
      </div>
      {filename ? (
        <div className="video-infos-container">
          <div className="name-indicator">Filename</div>
          <div className="file-name">{filename}</div>
        </div>
      ) : null}
    </div>
  )
}

export default VideoPreview
